import secrets from "./secrets";

const firebaseConfig = {
  apiKey: secrets.apiKey,
  authDomain: "edukos-ny.firebaseapp.com",
  databaseURL: "https://edukos-ny.firebaseio.com",
  projectId: "edukos-ny",
  storageBucket: "edukos-ny.appspot.com",
  messagingSenderId: secrets.messagingSenderId,
  appId: secrets.appId,
  measurementId: secrets.measurementId,
};

export default firebaseConfig;
